import React, { useState, useEffect } from 'react';

import {
  AiFillEye,
  AiOutlineDownload,
  AiOutlineCloudUpload,
  AiOutlinePlus,
} from 'react-icons/ai';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';

import { Table, Modal, Pagination } from 'antd';

import { toast } from 'react-toastify';

import { ClipLoader } from 'react-spinners';

import { CSVLink, CSVDownload } from 'react-csv';

import Swal from 'sweetalert2';

import history from '~/services/history';
import { IoMdArrowBack } from 'react-icons/io';

import api from '~/services/api';

import { store } from '~/store';

import Breadcumbs from '~/components/Breadcumbs';

import ModalReenviarLinhaDeCuidado from '~/components/ModalReenviarLinhaDeCuidado';
import ModalAlertaExcluirLinhaCuidado from '~/components/ModalAlertaExcluirLinhaCuidado';

import {
  PageTitle,
  BreadcumbsContainer,
  BoxAuth,
  BoxButtonDownload,
  BoxPagination,
} from './style';

import { catchErros } from '../LinhasDeCuidado/messages';

import { IdentificadordoPaciente } from './indentificadorPaciente';

import {
  getIndicadorLC,
  getNomeIndicador,
  getTitleIndicador,
  routersLc,
} from '../LinhasDeCuidado/careLinesInfo';

import columnAvc from './collumns/avc';
import columnSca from './collumns/sca';
import columnSepese from './collumns/sepse';
import columnQuadril from './collumns/quadril';
import columnProstata from './collumns/prostata';
import columnMam from './collumns/mam';

const LinhasDeCuidadoGrid = props => {
  const { token } = store.getState().auth;

  const [loading, setLoading] = useState(true);

  const [indicadorLinhaDeCuidado, SetIndicadorLinhaDeCuidado] = useState('');

  const [linhaDeCuidadoValue, setLinhaDeCuidadoValue] = useState(null);

  const [lc, setLc] = useState('');

  const [periodoSelecionado, setPeriodoSelecionado] = useState('');

  const [suggestedFileName, setSuggestedFileName] = useState('');

  const [titlePage, setTitlePage] = useState('');

  const [dataLinhaDeCuidado, setDataLinhaDeCuidado] = useState([]);

  const [collumnTable, setCollumnTable] = useState();

  const [modalReenviar, setModalReenviar] = useState(false);

  const [dataCsvDownload, setDataCsvDownload] = useState(null);

  const [modalCsvDownload, setModalCsvDownload] = useState(false);

  const [deletarLinha, setDeletarLinha] = useState(null);

  const [totalCount, setTotalCount] = useState(null);

  const [pageCurrent, setPageCurrent] = useState(1);

  const limit = 10000;

  const obterPeriodoLinhaDeCuidado = async () => {
    try {
      const response = await api.get(
        `/indicadores-linhas-de-cuidado/${linhaDeCuidadoValue}/periodo?limit=${limit}&offset=0&periodo=${periodoSelecionado}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      setTotalCount(response.headers['total-count']);
      const responseLinhaDeCuidado = [];

      if (response.data.length > 0) {
        response.data.forEach(value => {
          const data = value;

          data.periodoSelecionado = periodoSelecionado;
          data.linhaDeCuidadoValue = linhaDeCuidadoValue;
          data.linhaDeCuidado = indicadorLinhaDeCuidado;
          data.completo = value.isComplete == 'true' ? true : false;
          data.identificadordoPaciente = IdentificadordoPaciente(
            value,
            periodoSelecionado
          );
          responseLinhaDeCuidado.push(data);
        });
      }

      setDataLinhaDeCuidado(responseLinhaDeCuidado);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const paginationChange = async page => {
    setPageCurrent(page);
    setLoading(true);
    const limitOffset = page - 1;
    const offset = page <= 1 ? 0 : limitOffset * limit;

    try {
      const response = await api.get(
        `/indicadores-linhas-de-cuidado/${linhaDeCuidadoValue}/periodo?limit=${limit}&offset=${offset}&periodo=${periodoSelecionado}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      setTotalCount(response.headers['total-count']);
      const responseLinhaDeCuidado = [];
      if (response.data.length > 0) {
        response.data.forEach(value => {
          const data = value;
          data.periodoSelecionado = periodoSelecionado;
          data.linhaDeCuidadoValue = linhaDeCuidadoValue;
          data.linhaDeCuidado = indicadorLinhaDeCuidado;
          data.completo = value.isComplete == 'true' ? true : false;
          data.identificadordoPaciente = IdentificadordoPaciente(
            value,
            periodoSelecionado
          );
          responseLinhaDeCuidado.push(data);
        });
      }
      setDataLinhaDeCuidado(responseLinhaDeCuidado);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const paginationRender = (current, type, originalElement) => {
    if (type === 'prev') {
      return (
        <a className="arrowLeft">
          <MdKeyboardArrowLeft size={25} /> Anterior
        </a>
      );
    }
    if (type === 'next') {
      return (
        <a className="arrowRight">
          Próximo <MdKeyboardArrowRight size={25} />
        </a>
      );
    }
    return originalElement;
  };

  useEffect(() => {
    const { indicador } = props.match.params;

    setLc(indicador);
    const nomeIndicador = getNomeIndicador(indicador);

    const titleIndicador = getTitleIndicador(indicador);
    SetIndicadorLinhaDeCuidado(nomeIndicador);
    setLinhaDeCuidadoValue(indicador);

    setTitlePage(titleIndicador);
    if (props?.location?.state) {
      setPeriodoSelecionado(props?.location?.state?.periodo);
      setCollumnTable(
        (indicador === 'acidente_vascular_cerebral' && columnAvc) ||
          (indicador === 'sindrome_coronariana_aguda' && columnSca) ||
          (indicador === 'sepse_e_choque_septico' && columnSepese) ||
          (indicador === 'artropatia_de_quadril' && columnQuadril) ||
          (indicador === 'cancer_de_prostata' && columnProstata) ||
          (indicador === 'cancer_de_mama' && columnMam)
      );
    }

    if (props.location.state && props.location.state.deleteLinha) {
      setDeletarLinha(props.location.state.deleteLinha || null);
    }
  }, [props]);

  useEffect(() => {
    if (linhaDeCuidadoValue) {
      obterPeriodoLinhaDeCuidado();
    }
  }, [linhaDeCuidadoValue]);

  const downloadCsv = async () => {
    setModalCsvDownload(true);

    try {
      const response = await api.get(
        `indicadores-linhas-de-cuidado/${linhaDeCuidadoValue}/download-csv?periodo=${periodoSelecionado}&tipo=RECORD`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      setDataCsvDownload(response.data);

      if (response.headers?.['x-suggested-filename']) {
        setSuggestedFileName(response.headers?.['x-suggested-filename']);
      } else {
        setSuggestedFileName(
          `${linhaDeCuidadoValue}-${String(periodoSelecionado).replace(
            '/',
            '-'
          )}.csv`
        );
      }
    } catch (error) {
      catchErros(error);

      setModalCsvDownload(false);
    }
  };

  const dadosFaltantes = () => {
    history.push({
      pathname: `/linhas-de-cuidado-dados-faltantes/${linhaDeCuidadoValue}`,
      state: {
        periodo: periodoSelecionado,
      },
    });
  };

  const FichaDeColeta = () => {
    if (routersLc[getIndicadorLC(lc)]) {
      history.push({
        pathname: `/formulario-linhas-de-cuidado/${
          routersLc[getIndicadorLC(lc)]
        }`,
        state: {
          periodo: periodoSelecionado,
          indicador: lc,
          indicadorNome: indicadorLinhaDeCuidado,
        },
      });

      return;
    }
  };

  const exibeReenviarLinhaDeCuidado = () => {
    setModalReenviar(true);
  };

  return (
    <>
      <ModalAlertaExcluirLinhaCuidado
        deletarLinha={deletarLinha && true}
        setDeletarLinha={setDeletarLinha}
        data={{ linhaDeCuidadoValue, periodoSelecionado, id: deletarLinha }}
      />
      <Modal
        title="Baixe os dados no formato .CSV"
        visible={modalCsvDownload}
        onOk={() => {}}
        onCancel={() => setModalCsvDownload(false)}
        centered
        footer={false}
      >
        {dataCsvDownload ? (
          <BoxButtonDownload>
            <CSVLink
              className="botao-verde"
              filename={`${suggestedFileName}`}
              data={dataCsvDownload}
            >
              Download do .CSV
            </CSVLink>
          </BoxButtonDownload>
        ) : (
          <BoxButtonDownload>
            <p>Aguarde, carregando...</p>
          </BoxButtonDownload>
        )}
      </Modal>

      <ModalReenviarLinhaDeCuidado
        modalReenviar={modalReenviar}
        setModalReenviar={setModalReenviar}
        linhaDeCuidadoValue={linhaDeCuidadoValue}
        periodoSelecionado={periodoSelecionado}
      />
      <Breadcumbs
        path={linhaDeCuidadoValue || ''}
        pathTitle={`Adicionar Indicadores de Linhas de Cuidado / ${titlePage}`}
      />
      <BreadcumbsContainer>
        <div className="voltar">
          <button type="button" onClick={() => history.goBack()}>
            <IoMdArrowBack size={15} /> Voltar
          </button>
        </div>
      </BreadcumbsContainer>
      <PageTitle>
        <div>
          <span>{titlePage}</span>

          <h3>Competência: {periodoSelecionado}</h3>
        </div>

        <div className="buttons">
          <button type="button" onClick={dadosFaltantes}>
            <AiFillEye size={16} color="#FFF" />
            Dados faltantes
          </button>
          <button type="button" onClick={downloadCsv}>
            <AiOutlineDownload size={16} color="#FFF" />
            Exportar .csv
          </button>
          <button type="button" onClick={exibeReenviarLinhaDeCuidado}>
            <AiOutlineCloudUpload size={16} color="#FFF" />
            Reenviar .csv
          </button>
          <button
            type="button"
            className="novo-registro"
            onClick={FichaDeColeta}
          >
            <AiOutlinePlus size={16} color="#FFF" />
            Novo registro
          </button>
        </div>
      </PageTitle>

      {loading ? (
        <BoxAuth>
          <div className="boxSpin">
            <ClipLoader size={50} color="#74a50a" loading={loading} />
          </div>
        </BoxAuth>
      ) : (
        <BoxAuth>
          <div className="BoxAuthContainer">
            <Table
              columns={collumnTable}
              dataSource={dataLinhaDeCuidado}
              scroll={{ x: 1200 }}
              onRow={record => ({ rowKey: record.id })}
              // pagination={false}
              pagination={{
                defaultPageSize: 5,
                showSizeChanger: false,
              }}
            />
          </div>
        </BoxAuth>
      )}
    </>
  );
};

export default LinhasDeCuidadoGrid;
